import { TAppState } from '../../types/appState';

export const locationIdSelector = (state: TAppState) => state.locationId;
